import React, { Component } from 'react'
import {
  Wrapper,
  Background,
  BlackHalf,
  WhiteLabel,
  BlackLabel,
  WhiteRect,
  BlackRect
} from './styles'
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import { withRouter } from 'react-router-dom'

import theme from '../../theme'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mouseX: -1,
      mouseY: -1,
      width: 0,
      height: 0,
      showIntro: true
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this)
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onMouseMove(e) {
    this.setState({ mouseX: e.pageX, mouseY: e.pageY })
  }

  isTopTriangle() {
    // line, with 0,0 at top: y = (-∂X/∂Y)x + X
    const x =
      ((-1 * this.state.width) / this.state.height) * this.state.mouseY +
      this.state.width

    return x > this.state.mouseX
  }

  linkTo = link => {
    this.props.history.push(`/${link}`)
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }

  reset() {
    this.setState({ mouseX: -1, mouseY: -1 })
  }

  hideIntro() {
    this.setState({ showIntro: false })
  }

  hideIntroKey(event) {
    if (event.key === 'Enter') {
      this.hideIntro()
    }
  }

  render() {
    const angle =
      (Math.atan(this.state.height / this.state.width) * 180) / Math.PI
    const isOver = this.state.mouseX !== -1 && this.state.mouseY !== -1
    const isOverTop = this.isTopTriangle()

    if (this.state.width < 500) {
      return (
        <div>
          <WhiteRect onClick={() => this.props.history.push('/cs')}>
            CS
          </WhiteRect>
          <BlackRect onClick={() => this.props.history.push('/music')}>
            MUSIC
          </BlackRect>
        </div>
      )
    }

    return (
      <div>
        <Wrapper
          onMouseMove={this.onMouseMove.bind(this)}
          onMouseLeave={this.reset.bind(this)}
          onClick={() => {
            if (isOverTop) {
              this.props.history.push('/cs')
            } else {
              this.props.history.push('/music')
            }
          }}
        >
          <BlackHalf>
            <Background />
            <BlackLabel
              angle={angle}
              color={
                isOver && isOverTop
                  ? theme.colors.palePurple
                  : theme.colors.black
              }
            >
              {`CS\n `}
            </BlackLabel>
            <WhiteLabel
              angle={angle}
              color={isOver && !isOverTop ? '#a4a9c4' : theme.colors.white}
            >
              {` \nMUSIC`}
            </WhiteLabel>
          </BlackHalf>
        </Wrapper>
      </div>
    )
  }
}

export default withRouter(Home)



// WEBPACK FOOTER //
// ./src/containers/Home/index.js